exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-editor-container[data-v-4dfc1336]{background-color:#f0f2f5;min-height:100vh;padding:50px 60px 0px}.dashboard-editor-container .pan-info-roles[data-v-4dfc1336]{font-size:12px;font-weight:700;color:#333;display:block}.dashboard-editor-container .info-container[data-v-4dfc1336]{position:relative;margin-top:100px}.dashboard-editor-container .info-container .display_name[data-v-4dfc1336]{font-size:48px;line-height:48px;color:#212121}\n", ""]);

// exports
